$(document).ready(function () {
    if ($.cookie('cookieNotificationDisabled') != '1') {
        $('.cookie').show();
    }
    $('.cookie .cookie-close').on('click', function (e) {
        e.preventDefault();

        $.cookie('cookieNotificationDisabled', '1', {expires: 365, path: '/'});
        $(this).closest('.cookie').hide();

        return false;
    });
});